module.exports = __webpack_public_path__ + "static/img/strawberry-m.e59334c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/strawberry-m.jpg
// module id = FZJu
// module chunks = 0